import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";

import { Draft } from "immer";

export interface WarehouseDataState {
    isLoading: boolean;
    Warehouse?: WarehouseModel;
}

const initialState: WarehouseDataState = {
    isLoading: false,
    Warehouse: undefined,
};
const ChangeCustomerWarehouseDataReducer = {
    "Custom/Warehouse/BeginLoadWarehouse": (draft: Draft<WarehouseDataState>) => {
        draft.isLoading = true;
    },
    "Custom/Warehouse/CompletedLoadWarehouse": (
        draft: Draft<WarehouseDataState>,
        action: {
            result: any;
        },
    ) => {
        draft.Warehouse = action.result;
        draft.isLoading = false;
    },
};

export default createTypedReducerWithImmer(initialState, ChangeCustomerWarehouseDataReducer);
